/**
 * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
 */
export function isElementInViewport(el, fragOK) {
    if (typeof jQuery === 'function' && el instanceof jQuery) {
        el = el[0];
    }

    const rect = el.getBoundingClientRect();

    if (fragOK) {
        // test that top of element is in view -- for footer elements
        return (rect.top <= $(window).height());
    } else {
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= $(window).height() &&
            rect.right <= $(window).width()
        );
    }
}
